<template>
  <div id="app">
    <a-spin :spinning="globalLoading">
      <img
        src="@/assets/mainContentBox/loadding.png"
        width="150px"
        alt=""
        slot="indicator"
      />
      <router-view />
    </a-spin>
    <!-- 弹窗提示 -->
    <a-modal
      class="remainTime-modal"
      centered
      :title="logoutModal.title"
      :visible="logoutModal.visible"
      @cancel="logoutModalCancel"
      :footer="null"
    >
      {{ logoutModal.content }}
    </a-modal>
  </div>
</template>
<script>
import { gaLang } from '@/utils/googleAnalytics'
import { mapMutations, mapState, mapActions } from 'vuex'

export default {
  created () {
    window.addEventListener('beforeunload', () => {
      localStorage.setItem('isLogin', JSON.stringify(this.$store.state.isLogin))
      localStorage.setItem('remainingStartMill', JSON.stringify(this.$store.state.remainingStartMill))
      if (this.$store.state.eventInfo.id) {
        localStorage.setItem(`eventInfo-${this.$store.state.eventInfo.id}`, JSON.stringify(this.$store.state.eventInfo))
        localStorage.setItem(`eventConfig-${this.$store.state.eventInfo.id}`, JSON.stringify(this.$store.state.eventConfig))
        localStorage.setItem(`eventDates-${this.$store.state.eventInfo.id}`, JSON.stringify(this.$store.state.eventDates))
      }
      sessionStorage.setItem('selectTicketType', JSON.stringify(this.$store.state.selectTicketType))
    })
    // 常用的 langList
    const enList = ['en_us', 'en-us', 'en']
    const scList = ['zh_cn', 'zh-cn', 'cn', 'sc']
    const tcList = ['zh_tw', 'zh-tw', 'zh_hk', 'zh-hk', 'hk', 'tw', 'tc']

    let lang = ''

    /* 优先级最高 ?lang=xxx */
    const URLParams = new URLSearchParams(window.location.search)
    const urlParamsLang = URLParams.get('lang')?.toLowerCase()
    const _eventId = URLParams.get('event')
    if (_eventId) {
      try {
        const eventInfoStorage = JSON.parse(localStorage.getItem(`eventInfo-${_eventId}`))
        const eventConfigStorage = JSON.parse(localStorage.getItem(`eventConfig-${_eventId}`))
        const eventDatesStorage = JSON.parse(localStorage.getItem(`eventDates-${_eventId}`))
        if (eventInfoStorage) {
          this.setEventInfo(eventInfoStorage)
        }
        if (eventConfigStorage) {
          this.setEventConfig(eventConfigStorage)
        }
        if (eventDatesStorage) {
          this.setEventDates(eventDatesStorage)
        }
      } catch (err) {
        console.log('getEventInfo error:', err)
      }
    }

    if (enList.includes(urlParamsLang)) {
      lang = 'en_US'
    } else if (scList.includes(urlParamsLang)) {
      lang = 'zh_CN'
    } else if (tcList.includes(urlParamsLang)) {
      lang = 'zh_TW'
    } else {
      lang = null
    }
    // 不存在 url 的 lang
    if (!lang) {
      // 获取 springCookie ，用来判断 springCookie 是否存在合适的 lang
      const springLang = this.$Cookies.get('lang')?.toLowerCase() || this.$Cookies.get('org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE')?.toLowerCase()
      if (enList.includes(springLang)) {
        lang = 'en_US'
      } else if (scList.includes(springLang)) {
        lang = 'zh_CN'
      } else if (tcList.includes(springLang)) {
        lang = 'zh_TW'
      } else {
        lang = null
      }
    }

    // 不存在 springCookie 的 lang
    if (!lang) {
      // 获取浏览器语言
      const browserLang = (navigator.language || navigator.userLanguage)?.toLowerCase()
      if (enList.includes(browserLang)) {
        lang = 'en_US'
      } else if (scList.includes(browserLang)) {
        lang = 'zh_CN'
      } else {
        lang = 'zh_TW'
      }
    }

    this.$i18n.locale = lang
  },
  mounted () {
    gaLang()
    const cookieSize = this.$Cookies.get('cl-font-size')
    const size = this.$fontSizeList.includes(cookieSize) ? cookieSize : '16px'
    document.querySelector('html').style.fontSize = size
    this.$Cookies.set('cl-font-size', size, { domain: this.$CookieDomain, expires: 30 })
    this.setFontSize(size)

    const cookieThemeColor = this.$Cookies.get('cl-theme-color')
    const themeColor = this.$themeColorList.includes(cookieThemeColor) ? cookieThemeColor : this.$themeColorList[0]
    document.documentElement.setAttribute('data-theme', themeColor)
    this.$Cookies.set('cl-theme-color', themeColor, { domain: this.$CookieDomain, expires: 30 })
    this.setColor(themeColor)
    // this.getPersonalNotices()
  },
  computed: mapState(['logoutModal', 'globalLoading', 'isLogin', 'personalNotices']),
  watch: {
    isLogin (newVal) {
      console.log(newVal, this.personalNotices)
      if (newVal && !this.personalNotices) {
        // this.getPersonalNotices()
      } else {
        this.setPersonalNotices(null)
      }
    },
    globalLoading: {
      handler (newVal) {
        const $body = document.documentElement || document.body
        if (newVal) {
          $body.classList.add('fillHeight')
        } else {
          $body.classList.remove('fillHeight')
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations(['setFontSize', 'setColor', 'setPersonalNotices', 'setEventInfo', 'setEventConfig', 'setEventDates']),
    ...mapActions(['logoutModalCancel', 'getPersonalNotices'])
  }
}
</script>
<style lang="scss">
#app {
  @include background_color('default_background_color');
}
.modal-body {
  @include background_color('popup_bgc');
}

body {
  @include background_color('default_background_color');
  font-size: 1rem;
}
#app .bannerContent .slick-dots > li > button {
  @include background_color('navbar_verbar_color');
}
#app .bannerContent .slick-dots li.slick-active button {
  // @include background_color('darkTheme-background_color');
  background-color: #5577ff;
}
.tooltip.b-tooltip.bs-tooltip-bottom {
  > .arrow::before {
    @include border_color('b_hover_bgc');
    border-top-color: transparent !important;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
  }
  > .tooltip-inner {
    @include background_color('b_hover_bgc');
    @include font_color('b_hover_color');
  }
}

button:-moz-focusring,
a:-moz-focusring,
[tabindex='0']:-moz-focusring {
  @include tab_color(2px, 'black-border_color');
}

.ant-modal-title {
  color: #465aba;
  font-weight: 700;
  font-size: 1.3125rem;
  @media (max-width: 991px) {
    font-size: 1.125rem;
  }
}
.ant-modal-content {
  border-radius: 1.5625rem;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.ant-modal-header {
  border-radius: 1.5625rem 1.5625rem 0 0;
  border-bottom: none;
}
.ant-modal-body {
  padding-top: 16px;
  font-size: 1rem;
  color: #000;
  @media (max-width: 991px) {
    font-size: 0.875rem;
  }
}
.ant-modal-footer {
  border-top: none;
}

.remainTime-modal .ant-modal-wrap {
  z-index: 1005;
}

#app > .ant-spin-nested-loading {
  height: 100vh;
  .ant-spin-container {
    height: 100vh;
  }
  > div > .ant-spin {
    max-height: inherit;
    .ant-spin-dot {
      top: 50%;
      left: 50%;
      width: 150px;
      height: 150px;
      animation: loading 2s linear infinite;
    }
  }
}

@keyframes loading {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

.fillHeight {
  overflow: hidden;
  height: 100%;
}

.steps .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title{
  @include font_color('ant-step-active-color');
}
.steps .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
  @include font_color('ant-step-active-color');
}
.steps .ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
  @include font_color('ant-step-color');
}
.steps .ant-steps-item-title {
  padding: 0;
}

.ant-modal {
  .ant-modal-content {
    border: 1px solid transparent;
    @include border_color('modal-border-color');
    @include background_color('modal-bgc');
  }
  .ant-modal-header {
    @include background_color('modal-bgc');
  }
  .ant-modal-body {
    @include font_color('detail-title');
  }
  .ant-modal-close {
    @include font_color('default_color');
  }
}

.maxQuantityBox {
  .ant-modal-confirm-body .ant-modal-confirm-title {
    @include font_color('black-font_color');
  }
  .ant-modal-confirm-btns .ant-btn-primary {
    background: linear-gradient(90deg, #46baee 0%, #999dff 100%);
    border: none;
  }
}
</style>
